import { lazy } from 'react';

const WebsiteAd = lazy(() => import('./website-ad'));
const VideoAd = lazy(() => import('./video-ad'));
const LeadAd = lazy(() => import('./lead-ad'));

export { WebsiteAd, VideoAd, LeadAd };
